import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './SigninComponent.css'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import { withRouter } from 'react-router'
import { validateEmail, validatePassword } from 'redux/helpers/authHelpers'

class SigninComponent extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    authenticate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
  }
  state = {
    email: '',
    password: '',
    emailError: null,
    passwordError: null,
    errorMessage: void 0
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.auth && nextProps.auth.errorMessage !== void 0) {
      this.setState({ errorMessage: nextProps.auth.errorMessage })
    }
  }
  handleEmailChange = e => {
    this.setState({
      email: e.target.value,
      emailError: null,
      errorMessage: void 0
    })
  }
  handlePasswordChange = e => {
    this.setState({
      password: e.target.value,
      passwordError: null,
      errorMessage: void 0
    })
  }
  onKeyPressed = e => {
    if (e.charCode === 13) {
      // enter key pressed
      e.preventDefault()
      this.handleSigninClick()
    }
  }
  handleSignupClick = () => {
    this.props.history.replace('/signup')
  }
  handleResetPasswordClick = e => {
    this.props.history.replace('/resetPassword')
  }
  handleSigninClick = () => {
    if (!validateEmail(this.state.email)) {
      this.setState({ emailError: 'Email invalide' })
      return
    }
    if (!validatePassword(this.state.password)) {
      this.setState({
        passwordError: 'Mot de passe invalide, (6 caractères minimum)'
      })
      return
    }
    this.props.authenticate(this.state.email, this.state.password)
  }

  render() {
    const { errorMessage } = this.state
    const errorDiv = errorMessage ? (
      <div className="errorContainer">
        <span>{errorMessage}</span>
      </div>
    ) : null
    return (
      <section className="loginContainer">
        <Paper elevation={5} className="centerContainer">
          <div className="form">
            <Typography
              color="default"
              variant="display1"
              gutterBottom
              align="center">
              Connexion
            </Typography>
            <TextField
              autoFocus
              fullWidth
              error={!!this.state.emailError}
              label="Email"
              type="email"
              onChange={this.handleEmailChange}
              helperText={this.state.emailError}
            />
            <TextField
              fullWidth
              label="Mot de passe"
              type="password"
              error={!!this.state.passwordError}
              onKeyPress={this.onKeyPressed}
              onChange={this.handlePasswordChange}
              helperText={this.state.passwordError}
            />
            <Button
              style={{ marginTop: '10px' }}
              onClick={this.handleSigninClick}
              variant="raised"
              size="large"
              color="primary">
              Connexion
            </Button>
            {errorDiv}
            <div style={{ marginTop: '10px' }}>
              <Typography variant="caption">Mot de passe oublié ? </Typography>
              <Button size="small" onClick={this.handleResetPasswordClick}>
                {' '}
                Cliquez ici{' '}
              </Button>
            </div>
            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
            <Typography variant="body1" gutterBottom>
              Vous n'avez pas de compte :
            </Typography>
            <Button
              variant="raised"
              size="small"
              onClick={this.handleSignupClick}
              color="secondary">
              Créer un compte
            </Button>
          </div>
        </Paper>
      </section>
    )
  }
}
export default withRouter(SigninComponent)



// WEBPACK FOOTER //
// ./src/routes/Signin/components/SigninComponent.js